import { nanoid } from 'nanoid';

export const randomId = () => (
  window.isSecureContext
    ? crypto.randomUUID()
    : nanoid(8)
);
